import { Flex, Grid, Tooltip } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import dayjs from 'dayjs'
import _, { capitalize } from 'lodash'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { Color } from '../../../Common/Color'
import { t } from 'i18next'
import PublicContext from '../../PublicContext'
import MobileBoxAppointmentList from '../Mobile/MobileBoxAppointmentList'
import ComputerBoxAppointmentList from '../Computer/ComputerBoxAppointmentList'
import TabletBoxAppointmentList from '../Tablet/TabletBoxAppointmentList'
import { screenSize } from '../../../Common/Common'
const { useBreakpoint } = Grid

const daysListStyle = {
  xs: {
    fontSize: '20px',
    marginTop: '1em',
    marginBottom: '0.5em',
    textAlign: 'center'
  },
  other: {
    fontSize: '20px',
    marginTop: '1em',
    marginBottom: '0.5em'
  }
}

export const slotTitle = (day) => {
  if (dayjs(day).isSame(dayjs(), 'day')) {
    return t('Public.BoxList.today')
  } else {
    return dayjs(day).format('dddd D MMMM')
  }
}

export default function BoxAppointmentList () {
  const screens = useBreakpoint()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [days, setDays] = useState([])
  const { box, setSiderTitle, slots, getSlots } = useContext(PublicContext)

  const availableSlot = (slot) => (
    <div
      className='hoverable'
      key={dayjs(slot.start_date).format('dd/mm/yyyy HH:mm')}
      onClick={() => onClick(slot.start_date)}
      style={{
        textAlign: 'center',
        width: '115px',
        display: 'inline-block',
        fontSize: '16px',
        border: '1px solid black',
        borderRadius: '2em',
        padding: '0.4em 1em',
        '--hover-color': Color.red,
        '--hover-border-color': Color.red,
        cursor: 'pointer'
      }}>
      {dayjs(slot.start_date).format('HH:mm')}
    </div>
  )

  const unavailableSlot = (slot) => (
    <Tooltip title={t('Public.BoxPage.unavailable')}>
      <div
        className='hoverable'
        key={dayjs(slot.start_date).format('dd/mm/yyyy HH:mm')}
        style={{
          textAlign: 'center',
          width: '115px',
          display: 'inline-block',
          fontSize: '16px',
          border: '1px solid black',
          borderRadius: '2em',
          padding: '0.4em 1em',
          backgroundColor: 'lightgrey'
        }}>
        {dayjs(slot.start_date).format('HH:mm')}
      </div>
    </Tooltip>
  )

  useEffect(() => {
    if (slots) {
      const filteredSlots = slots.filter((slot) => dayjs(slot.start_date) >= dayjs())
      setDays(_.groupBy(filteredSlots, (slot) => {
        return dayjs(slot.start_date).format('YYYY-MM-DD')
      }))
    }
  }, [slots])

  const onClick = (slot) =>
    navigate(`/box/${box.id}/appointment_create?date=${dayjs(slot).toString()}`)

  const hourList = (slots) => (
    <Flex gap='1em' wrap>
      {
        slots.map((slot) => (
          slot.appointment_id || slot.closed ? unavailableSlot(slot) : availableSlot(slot)
        ))
      }
    </Flex>
  )

  const increasedHourList = (slots) => {
    const displayed = []
    for (const [i, value] of slots.entries()) {
      let condition = false
      if (slots[i + 1] && i < slots.length - 2) {
        condition = slots[i + 1].closed || slots[i + 1].appointment_id || value.closed || value.appointment_id
      } else {
        condition = value.appointment_id || value.closed
      }
      displayed[i] = condition ? unavailableSlot(value) : availableSlot(value)
    }
    return (
      <Flex gap='1em' wrap>
        { displayed }
      </Flex>
    )
  }

  const more = () => {
    const newValue = Object.keys(days).reduce(
      (max, date) => (dayjs(date) > max ? dayjs(date) : max),
      dayjs()
    )
    getSlots(box.id, newValue.add(1, 'day'), { reset: false })
  }

  const dayDisplay = (day) => (
    <div key={slotTitle(day)} style={{ margin: '0 4%' }}>
      <div style={screens.xs ? daysListStyle.xs : daysListStyle.other}>
        {capitalize(slotTitle(day))}
      </div>
      { box.increased_slot_duration && increasedHourList(days[day]) }
      { !box.increased_slot_duration && hourList(days[day]) }
    </div>
  )

  const daysList = (slotList) => {
    const displayedDays = Object.keys(slotList)
    const days = _.take(displayedDays, displayedDays.length)
    return days.map(dayDisplay)
  }

  useEffect(() => {
    setSiderTitle(t('Public.BoxPage.title'))
  }, [])

  const slotsList = {
    Mobile: MobileBoxAppointmentList,
    Computer: ComputerBoxAppointmentList,
    Tablet: TabletBoxAppointmentList
  }

  const ResponsiveList = slotsList[screenSize()]

  return (
    <ResponsiveList box={box} daysList={daysList(days)} more={more} />
  )
}
